import { render, staticRenderFns } from "./CourseManager.vue?vue&type=template&id=49516fa8&scoped=true&"
import script from "./CourseManager.vue?vue&type=script&lang=js&"
export * from "./CourseManager.vue?vue&type=script&lang=js&"
import style0 from "./CourseManager.vue?vue&type=style&index=0&id=49516fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49516fa8",
  null
  
)

export default component.exports